import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import articles from "@/content/clanky.json";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

export default function Clanky() {
  useEffect(() => {
    document.title = "Rady pro klienty | Daniel Pekař";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Praktické rady k hypotékám, úvěrům a pojištění — dokumenty, rejstříky a na co si dát pozor, srozumitelně a bez odborných pojmů.");
    return () => { document.title = "Daniel Pekař – finanční poradce Ústí nad Labem"; };
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-32 pb-24 md:pt-40 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Rady pro klienty
          </p>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.12] text-[#252525] mt-6">
            Co se vyplatí vědět předem
          </h1>
          <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed mt-8">
            Praktické návody k hypotékám, úvěrům i pojištění — kde co vyřídit online,
            jaké dokumenty připravit a na co si dát pozor. Srozumitelně, bez odborných pojmů.
          </p>

          <div className="mt-14 space-y-10">
            {articles.map((article) => (
              <article key={article.slug} data-testid={`clanek-card-${article.slug}`} className="border border-[#F0F0F0] p-8 md:p-10 hover:border-[#B69A58] transition-colors duration-300">
                <p className="text-xs uppercase tracking-widest text-[#B69A58] font-medium">
                  {article.category}
                  <span className="text-[#737373] font-normal">
                    {" · "}{new Date(article.date).toLocaleDateString("cs-CZ", { day: "numeric", month: "long", year: "numeric" })}
                  </span>
                </p>
                <h2 className="font-display text-2xl md:text-3xl leading-snug text-[#252525] mt-4">
                  <Link to={`/rady/${article.slug}`} data-testid={`clanek-link-${article.slug}`} className="hover:text-[#B69A58] transition-colors duration-300">
                    {article.title}
                  </Link>
                </h2>
                <p className="text-base text-[#4A4A4A] leading-relaxed mt-4">{article.excerpt}</p>
                <Link
                  to={`/rady/${article.slug}`}
                  data-testid={`clanek-cta-${article.slug}`}
                  className="group mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-widest font-medium text-[#252525] hover:text-[#B69A58] transition-colors duration-300"
                >
                  Číst radu
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                </Link>
              </article>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
